import React, { useMemo } from 'react'
import { useGtiContext } from '@maui/app-gti'
import { RootContext } from '../contexts/RootContext'

export const RootContextProvider = props => {
  const { links } = useGtiContext()

  const value = useMemo(() => ({
    links
  }), [
    links,
  ])

  return (
    <RootContext.Provider value={value} {...props} />
  )
}
